import React, { useState, useRef, useCallback } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core';

function getCroppedImg(image, crop) {
    const canvas = document.createElement('canvas');
    canvas.width = 140;
    canvas.height = 200;
    const ctx = canvas.getContext('2d');

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        140,
        200
    );

    return canvas.toDataURL('image/jpeg');
}

export default function ImageCropDialog({ open, imageSrc, onConfirm, onClose }) {
    const imgRef = useRef(null);
    const [crop, setCrop] = useState({ aspect: 140 / 200 });

    const onImageLoaded = useCallback((img) => {
        imgRef.current = img;
        const aspect = 140 / 200;
        const imgAspect = img.width / img.height;
        let newCrop;
        if (imgAspect > aspect) {
            const cropHeight = img.height;
            const cropWidth = cropHeight * aspect;
            newCrop = {
                x: (img.width - cropWidth) / 2,
                y: 0,
                width: cropWidth,
                height: cropHeight,
                aspect,
            };
        } else {
            const cropWidth = img.width;
            const cropHeight = cropWidth / aspect;
            newCrop = {
                x: 0,
                y: (img.height - cropHeight) / 2,
                width: cropWidth,
                height: cropHeight,
                aspect,
            };
        }
        setCrop(newCrop);
        return false;
    }, []);

    const handleConfirm = () => {
        if (imgRef.current && crop.width && crop.height) {
            const croppedImage = getCroppedImg(imgRef.current, crop);
            onConfirm(croppedImage);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Recortar Foto</DialogTitle>
            <DialogContent style={{ textAlign: 'center', overflow: 'hidden' }}>
                {imageSrc && (
                    <ReactCrop
                        src={imageSrc}
                        crop={crop}
                        onChange={setCrop}
                        onImageLoaded={onImageLoaded}
                        keepSelection
                        imageStyle={{ maxWidth: '100%', maxHeight: '60vh' }}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleConfirm} color="primary" variant="contained">
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
